import Layout from '@/views/layout/index.vue'
let aboutUsRouter = {
    path: '/aboutUs',
    component: Layout,
    redirect: '/aboutUs/index',
    meta: {
        title: '关于我们',
        // noCache: true
    },
    children: [
        {
            path: 'index',
            name: 'AboutUs',
            component: () => import('@/views/aboutUs/index.vue'),
            meta: {
                title: '关于我们',
                // noCache: true
            }
        }
    ]
}


export default aboutUsRouter